import styled from "styled-components";
import {ContainerDefaultBox} from "./container.default.box";

export const ContainerMrGreenBox = styled(ContainerDefaultBox)`
    background-color: ${props => props.theme.colors.background};
    border-radius: 8px;
    padding: 0px 2rem 1rem 2rem;
`;